export class DadosInadimplenciaDTO {

    Cgc: string;
    Titulos: TituloInadimplenciaDTO[];

    constructor(data: any = {}) {
        this.Cgc = data.Cgc;
        this.Titulos = (data.Titulos && data.Titulos.map(e => new TituloInadimplenciaDTO(e))) || [];
    }

    PossuiInadimplencia(): boolean {
        return !!this.Titulos.length;
    }
}

export class TituloInadimplenciaDTO {
    // "NOTA": "000091583",
    // "PARCELA": "",
    // "EMISSAO": "20221212",
    // "VENCIMENTO": "20221212",
    // "VALOR": 93744,
    // "SALDO": 93744

    public Nota: string;
    public Parcela: string;
    public Emissao: Date;
    public Vencimento: Date;
    public Valor: number;
    public Saldo: number;

    constructor(data: any = {}) {
        this.Nota = data.Nota;
        this.Parcela = data.Parcela;
        this.Emissao = data.Emissao && new Date(data.Emissao);
        this.Vencimento = data.Vencimento && new Date(data.Vencimento);
        this.Valor = data.Valor;
        this.Saldo = data.Saldo;
    }
}